import React, { Component } from "react";
import { Menu } from "@mui/material";
import { withRouter } from "../../../withRouter";
import { InputAdornment } from "@mui/material";
import moment from "moment-timezone";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@material-ui/core/Tooltip";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Button from "@material-ui/core/Button";
// import ForumIcon from "@mui/icons-material/Forum";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  GetForTestAndSend_Url,
  GroupList_Url,
  MessageLogDelete_Url,
  ScheduledSendList_Url,
  ScheduledSMS_Url,
  SmsActivityList_Url,
} from "../../../provider/ServiceUrl";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import DeleteButton from "../buttons/DeleteButton";
import "./ScheduleSendList.css";
import PtsAlert from "../ptsAlert/PtsAlert";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import GroupLogListDialog from "./GroupLogListDialog";
import ActivityLogListDialog from "./ActivityLogListDialog";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import Pagination from "../pagination/Pagination";
import CancelButtons from "../buttons/CancelButtons";
import _ from "lodash";
import PtsDateTimePicker from "../ptsDateTime/PtsDateTimePicker";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import ActivityContactList from "../activityContacts/ActivityContactList";
import GroupContactsDialog from "../activityContacts/GroupContactsDialog";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import MessagePrivewDialog from "../sendHistory/MessagePrivewDialog";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
class ScheduledSendList extends Component {
  header = store.getState().header.header;
  countryListArray = store.getState().staticData.countryList;
  defaultCountry = store.getState().staticData.defaultCountry;
  eventTimeZone = store.getState().businessDomain?.eventTimeZone
  orgTimeZone = store.getState().appUserData?.organizationDetails?.timezone;
  scheduledSendState = store.getState().applicationState.scheduledSendState;
  paginationState = store.getState().paginations.scheduledSendState;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  breadCrumb = [{ pageid: "", uiname: "Scheduled Sends" }];
  scheduledSendStateDetails = {};
  paginationStateDetails = {};
  recipientInterval = null;
  constructor(props) {
    super(props);
    if (this.scheduledSendState) {
      this.scheduledSendStateDetails = Object.getOwnPropertyNames(
        this.scheduledSendState
      );
    }

    if (this.paginationState) {
      this.paginationStateDetails = Object.getOwnPropertyNames(
        this.paginationState
      );
    }

    if (this.scheduledSendStateDetails.length > 0) {
      this.state = {
        pageNo: this.scheduledSendState.pageNo,
        pageSize: this.scheduledSendState.pageSize,
        messageId: this.scheduledSendState.messageId,
        scheduledSendList: [],
        smsGroupList: [],
        smsGroupsId: [],
        activitieIds: [],
        smsActivityList: [],
        recipientTypeList: [],
        recipientType: null,
        reminderType: Utils.getArrayElement(this.reminderTypes, 0),
        ScheduledToSend: true,
        scheduledDateTime: new Date(),
        reminderMobileNo: "",
        reminderEmail: "",
        sendReminder: false,
        scheduleErrorMessage: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        isScheduledOpen: false,
        render: false,
        open: false,
        sortColumn: this.scheduledSendState?.sortColumn,
        isAscSort: this.scheduledSendState?.isAscSort,
        sortDirection: "asc",
        searchText: "",
      };
    } else {
      this.state = {
        messageId: "",
        pageNo: 0,
        pageSize:
          this.paginationStateDetails?.length > 0
            ? this.paginationState?.pageSize
            : 100,
        scheduledCount: 0,
        scheduledDateTime: new Date(),
        reminderMobileNo: "",
        reminderEmail: "",
        sendReminder: false,
        scheduledSendList: [],
        smsGroupList: [],
        smsGroupsId: [],
        activitieIds: [],
        smsActivityList: [],
        recipientTypeList: [],
        recipientType: null,
        reminderType: Utils.getArrayElement(this.reminderTypes, 0),
        scheduleErrorMessage: false,
        ScheduledToSend: true,
        open: false,
        isScheduledOpen: false,
        getUpdatePermission: false,
        getDeletePermission: false,
        render: false,
        sortColumn: this.paginationStateDetails?.length > 0
          ? this.paginationState?.sortColumn : null,
        isAscSort: this.paginationStateDetails?.length > 0
          ? this.paginationState?.isAscSort : false,
        sortDirection: "asc",
        searchText: "",
      };
    }
    this.getScheduledSendList(this.state.pageNo, this.state.pageSize);
    this.debouncedSearch = _.debounce(this.getScheduledSendList, 800);
  }

  getScheduledSendList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };
    FetchServerData.callPostService(ScheduledSendList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let scheduledSendList = output.data.smsMessageLogList;
          let page = output.data.page;
          let smsCredits = output.data.smsCredits;
          let getPermission = Utils.getRolePermission(
            output.data?.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];

          if (smsCredits !== null) {
            const { showCardexpiryMessage, ...smsCreditsWithoutFlag } = smsCredits;

            if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
              store.dispatch(
                SelectedDomainAction.setEventCreditUsage(smsCreditsWithoutFlag)
              );
            } else {
              store.dispatch(
                AppUserDataAction.setUsage(smsCreditsWithoutFlag)
              );
            }
          }
          let scheduledCount = 0;
          for (let i = 0; i < scheduledSendList.length; i++) {
            scheduledSendList[i].scheduledDateTime = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(scheduledSendList[i].scheduledDate, true) :
              Utils.getUtcToLocalDateTimeZone(scheduledSendList[i].scheduledDate, true);
            scheduledSendList[i].scheduledExpired =
              Date.parse(scheduledSendList[i].scheduledDate) <
              Date.parse(new Date());
            if (!scheduledSendList[i].scheduledExpired) scheduledCount++;
          }

          if (this.isComponentMounted && this.isAnyMessageSending(scheduledSendList)) {
            this.startRecipientAutoRefresh();
          } else {
            this.stopRecipientAutoRefresh();
          }

          this.setState({
            render: true,
            scheduledSendList: scheduledSendList,
            scheduledCount: scheduledCount,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      }
    );
  }


  isAnyMessageSending = (list) => {
    return list?.some(
      (item) => item.status?.toLowerCase() === "scheduling"
    );
  };

  componentDidMount() {
    this.isComponentMounted = true;
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
    this.stopRecipientAutoRefresh();
  }

  startRecipientAutoRefresh = () => {
    if (this.recipientInterval) return;
    this.recipientInterval = setInterval(() => {
      if (!this.isComponentMounted) return;
      this.getScheduledSendList(this.state.pageNo, this.state.pageSize);
    }, 12000);
  };

  stopRecipientAutoRefresh = () => {
    if (this.recipientInterval) {
      clearInterval(this.recipientInterval);
      this.recipientInterval = null;
    }
  };


  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;

    const scheduledSendState = {
      pageSize: pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSheduledSendPaginationState({ scheduledSendState })
    );
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.getScheduledSendList(currentPageIndex, pageSize, this.state.sortColumn, this.state.isAscSort);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ pageNo: page, pageSize: pageSize });
  }

  deleteMessageLogHistory(data) {
    const postObject = {
      header: this.header,
      page: {
        searchText: this.state.searchText,
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
      messageLog: {
        id: data.id,
      },
    };
    FetchServerData.callPostService(MessageLogDelete_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getScheduledSendList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        } else {
        }
      })
      .catch((error) => { });
  }
  cancelScheduledSend(data) {
    const postObject = {
      header: this.header,
      page: {
        searchText: this.state.searchText,
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
      messageLog: {
        id: data.id,
      },
    };
    FetchServerData.callPostService(MessageLogDelete_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getScheduledSendList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
        } else {
        }
      })
      .catch((error) => { });
  }

  getScheduledDateTime(UtcDate) {
    if (!UtcDate) return "";

    let timeZone = this.businessDomain === BUSINESS_DOMAIN.eventText ? this.eventTimeZone : this.orgTimeZone;
    let formattedDate = "";

    if (timeZone?.name) {
      formattedDate = moment
        .utc(UtcDate)
        .tz(timeZone?.name)
        .format("YYYY-MM-DDTHH:mm:ss.SSS");
    } else {
      formattedDate = moment
        .utc(UtcDate)
        .local()
        .format("MM/DD/YYYY (ddd) - hh:mm a");
    }

    return formattedDate;
  };

  editMessageDetails(e, data) {
    const scheduledDateTime = this.getScheduledDateTime(data.scheduledDate);
    let messageState = {
      messageId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ messageState })
    );
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventScheduleSend", {
        state: {
          messageLogId: data.id,
          scheduledDateTime: scheduledDateTime,
          messageName: data.messageName,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextScheduleSend", {
        state: {
          messageLogId: data.id,
          scheduledDateTime: scheduledDateTime,
          messageName: data.messageName,
        },
      });
    } else {
      this.props.navigate("/scheduleSend", {
        state: {
          messageLogId: data.id,
          scheduledDateTime: scheduledDateTime,
          messageName: data.messageName,
        },
      });
    }
  }

  toGroupLogList(data) {
    if (this.groupListDialogueRef && this.groupListDialogueRef.current) {
      this.groupListDialogueRef.current.showGroupLogList(data, "ScheduledSend");
    }
  }
  toActivityLogList(data) {
    if (this.ActiveListDialogueRef && this.ActiveListDialogueRef.current) {
      this.ActiveListDialogueRef.current.showActivityLogList(data);
    }
  }

  showActionButton(rowData) {
    return (
      <>
        <div className="row d-flex">
          <div className="col-md-8 d-flex" style={{ display: "inline-flex" }}>
            {(rowData.groupCount > 0 || rowData.activityCount > 0) && (
              <Tooltip
                arrow
                title="Groups Selected"
                classes={{ popper: "custom-tooltip" }}
              >
                {/* <a
                  href="#"
                  style={{ cursor: "pointer", marginTop: "2px" }}
                  onClick={this.toGroupLogList.bind(this, rowData)}
                >
                  <i
                    className="menu-icon tf-icons fas fa-users"
                    style={{
                      color: "#6A7B8E",
                      fontSize: "19px",
                      padding: "3px",
                    }}
                  ></i>
                </a> */}
                <button
                  type="button"
                  onClick={() => this.toGroupLogList(rowData)}
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    padding: 0,
                    marginTop: "2px",
                  }}
                  aria-label="View group log"
                >
                  <i
                    className="menu-icon tf-icons fas fa-users"
                    style={{
                      color: "#6A7B8E",
                      fontSize: "19px",
                      padding: "3px",
                    }}
                  ></i>
                </button>
              </Tooltip>
            )}

            {this.state.getDeletePermission && (
              <span className="ms-2" style={{ cursor: "pointer" }}>
                {rowData.status !== "Scheduled" ? (
                  <DeleteButton
                    pageId="scheduledSend"
                    // title={rowData.messageName}
                    // domainObject={rowData.messageName}
                    onClick={this.deleteMessageLogHistory.bind(this, rowData)}
                  />
                ) : (
                  // <span
                  //   style={{
                  //     cursor: "pointer",
                  //     fontSize: "x-larger",
                  //     alignItems: "center",
                  //     marginRight: "6px",
                  //   }}
                  // >
                  //   <CancelIcon
                  //     style={{
                  //       color: "red",
                  //       cursor: "pointer",
                  //       fontSize: "x-larger",
                  //       alignItems: "center",
                  //       minHeight: "30px",
                  //     }}
                  //     onClick={this.cancelScheduledSend.bind(this, rowData)}
                  //   />
                  // </span>
                  <CancelButtons
                    // title={rowData.messageName}
                    // domainObject={rowData.messageName}
                    pageId="scheduledCancelled"
                    onClick={this.cancelScheduledSend.bind(this, rowData)}
                  />
                )}
              </span>
            )}
            {/* {rowData.activityCount > 0 ? (
              <Tooltip title="Activitys">
                <a
                  href="#"
                  className="ms-2"
                  style={{ cursor: "pointer", marginTop: "2px" }}
                  onClick={this.toActivityLogList.bind(this, rowData)}
                >
                  <ForumIcon
                    style={{
                      color: "#6A7B8E",
                      fontSize: "28px",
                      padding: "3px",
                    }}
                  />
                </a>
              </Tooltip>
            ) : (
              <span style={{ marginLeft: "35px" }}></span>
            )} */}
            {/* <span className="ms-2" style={{ cursor: "pointer" }}>
              <EditButton
                onClick={this.editMessageDetails.bind(this, rowData)}
              />
            </span> */}
          </div>
        </div>
      </>
    );
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e, rowData) => {
    let anchorEl = e.currentTarget;
    if (
      this.messagePreviewDialogueRef &&
      this.messagePreviewDialogueRef.current
    ) {
      this.messagePreviewDialogueRef.current.showMessagePreview(
        anchorEl,
        rowData
      );
    }
  };

  toRecipientsDetailList(e, data) {
    let scheduledSendState = {
      messageId: data.id,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      sortColumn: this.state.sortColumn,
      isAscSort: this.state.isAscSort,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ scheduledSendState })
    );

    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventRecipientsList", {
        state: {
          smsMessageLog: data,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/recipientsList", {
        state: {
          smsMessageLog: data,
        },
      });
    } else {
      this.props.navigate("/recipientsList", {
        state: {
          smsMessageLog: data,
        },
      });
    }
  }
  scheduledDilogBoxOpen(e, data) {
    this.getMessageDetails(data.messageId);
    this.setState({
      isScheduledOpen: true,
    });
  }
  scheduledDilogBoxClose() {
    this.setState({
      isScheduledOpen: false,
    });
  }

  getMessageDetails(messageId) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: messageId,
      },
    };
    FetchServerData.callPostService(GetForTestAndSend_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsMessage = output.data.smsMessage;
          let recipientTypeList = output.data.recipientTypeList;
          let smsActivityList = output.data.activityList;
          let smsGroupList = output.data.groupList;

          this.setState({
            render: true,
            messageId: smsMessage.id,
            messageName: smsMessage.messageName,
            messageType: smsMessage.messageType,
            keyword: smsMessage.keyword,
            textMessage: smsMessage.textMessage,
            recipientType: Utils.getArrayElement(recipientTypeList, 0),
            recipientTypeList: recipientTypeList,
            smsGroupList: smsGroupList,
            smsActivityList: smsActivityList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  scheduleSendToBackend() {
    if (!this.state.sendToAllOptins) {
      if (
        this.state.smsGroupsId.length === 0 &&
        this.state.activitieIds.length === 0
      ) {
        PtsAlert.error("Please select the group");
        return;
      }
    }

    if (
      this.state.sendReminder &&
      this.state.reminderMobileNo === "" &&
      this.state.reminderEmail === ""
    ) {
      this.setState({
        reminderErrorMessage: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      message: {
        id: this.state.messageId,
      },

      scheduledDateTime: moment(this.state.scheduledDateTime).format(
        "yyyy-MM-DDTHH:mm:ss.SSS"
      ),
      groups: this.state.smsGroupsId,
      activities: this.state.activitieIds,
      avoidRepeatSend: this.state.avoidRepeatSend,
      sendToAllOptins: this.state.sendToAllOptins,
      recipientType: this.state.recipientType,
      reminder: {
        countryCode: this.state.reminderCountryCode,
        mobile: this.state.reminderMobileNo,
        email: this.state.reminderEmail,
        reminderType: this.state.reminderType,
      },
    };
    FetchServerData.callPostService(ScheduledSMS_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // let creditUsage = output.data.creditUsage;
          this.setState({
            isScheduledOpen: false,
          });
        } else {
        }
      }
    );
  }

  avoidRepeatSendMessages(e) {
    this.setState({
      avoidRepeatSend: e.target.checked,
    });
  }
  onGroupClicked(e, groupId) {
    let smsGroupsId = this.state.smsGroupsId;
    if (e.target.checked) {
      this.setState({
        smsGroupsId: [...smsGroupsId, groupId],
      });
    } else {
      let index = smsGroupsId.indexOf(groupId);
      smsGroupsId.splice(index, 1);
      this.setState({
        smsGroupsId: smsGroupsId,
      });
    }
  }

  onActivityClicked(e, activityId) {
    let activitieId = this.state.activitieIds;
    if (e.target.checked) {
      this.setState({
        activitieIds: [...activitieId, activityId],
      });
    } else {
      let index = activitieId.indexOf(activityId);
      activitieId.splice(index, 1);
      this.setState({
        activitieIds: activitieId,
      });
    }
  }

  toActivityDetails(data) {
    let activityData = Object.assign(data, { messageId: this.state.messageId });
    if (
      this.activityContactDialogueRef &&
      this.activityContactDialogueRef.current
    ) {
      this.activityContactDialogueRef.current.showActivityContactList(
        activityData
      );
    }
  }

  toGroupDetails(data) {
    if (this.groupContactDialogueRef && this.groupContactDialogueRef.current) {
      this.groupContactDialogueRef.current.showGroupContactList(data);
    }
  }

  handleRecipientTypeChange(selectedValue) {
    let sendToAllOptins = false;
    if (selectedValue.type === "AllOptins") {
      sendToAllOptins = true;
    }
    this.setState({
      recipientType: selectedValue,
      sendToAllOptins: sendToAllOptins,
    });
  }

  handleScheduledToSendChange() {
    this.setState({ ScheduledToSend: true, sendNow: false });
  }
  handleSendNowChange() {
    this.setState({
      ScheduledToSend: false,
      sendNow: true,
      scheduledDateTime: new Date(),
      reminderMobileNo: "",
      reminderEmail: "",
      sendReminder: false,
      scheduleErrorMessage: false,
    });
  }
  handleSendReminderChange(e) {
    this.setState({
      sendReminder: e.target.checked,
      reminderErrorMessage: false,
    });
  }

  handleScheduledDateTimeChange(date) {
    const diffTime = Math.abs(new Date() - date?.dateTime);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // const diffTime1 = Math.abs(new Date() - date?.dateTime);
    // const diffSecond = Math.ceil(diffTime1 / 1000);
    if (diffDays >= 2) {
      this.setState({
        render: true,
        scheduledDateTime: date?.dateTime,
        scheduleErrorMessage: true,
        isReminderTimer: true,
      });
    } else {
      this.setState({
        render: true,
        scheduledDateTime: date?.dateTime,
        scheduleErrorMessage: false,
        isReminderTimer: true,
      });
    }
  }
  handleReminderTypeChange(selectedValue) {
    if (selectedValue?.type === "Mobile") {
      this.setState({
        reminderType: selectedValue,
        reminderEmail: "",
      });
    } else if (selectedValue?.type === "Email") {
      this.setState({
        reminderType: selectedValue,
        reminderMobileNo: "",
      });
    } else
      this.setState({
        reminderType: selectedValue,
      });
  }
  handleReminderMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        reminderMobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleReminderEmailChange(e) {
    this.setState({
      reminderEmail: e.target.value,
    });
  }

  navigateOrgTimeZone() {
    store.dispatch(SelectedTabAction.setSelectedTab(0));
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    this.props.navigate("/settings");
  }
  getSmsGroupList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.setState({
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  getSmsActivityList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(SmsActivityList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsActivityList = output.data.activityList;
          this.setState({
            smsActivityList: smsActivityList,
          });
        } else {
        }
      }
    );
  }

  handleRowClick = (e, rowData) => {
    // Skip if clicking on action buttons
    if (e.target.closest(".action-button")) return;

    this.handleAccountDropdownOpen(e, rowData);
  };

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const scheduledSendState = {
      pageSize: pageSize,
      sortColumn: column,
      isAscSort: isAscSort,
    };
    store.dispatch(
      PaginationRowAction.setSheduledSendPaginationState({ scheduledSendState })
    );
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort
      },
      () => {
        this.getScheduledSendList(pageNo, pageSize, column, isAscSort);
      }
    );
  }
  render() {
    this.groupListDialogueRef = React.createRef();
    this.ActiveListDialogueRef = React.createRef();
    this.activityContactDialogueRef = React.createRef();
    this.groupContactDialogueRef = React.createRef();
    this.messagePreviewDialogueRef = React.createRef();
    const validCountryCodes = this.countryListArray
      ?.filter((country) => ["US", "CA", "AU", "IN"].includes(country.code))
      .map((country) => country.code.toLowerCase());
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name="View and manage your scheduled texts"
          isSearchText={this.state.searchText !== ""}
        />
        <GroupLogListDialog
          ref={this.groupListDialogueRef}
          style={{ float: "right" }}
        />
        <ActivityLogListDialog
          ref={this.ActiveListDialogueRef}
          style={{ float: "right" }}
        />
        <ActivityContactList
          ref={this.activityContactDialogueRef}
          style={{ float: "right" }}
          onChange={this.getSmsActivityList.bind(this)}
        />
        <GroupContactsDialog
          ref={this.groupContactDialogueRef}
          style={{ float: "right" }}
          onChange={this.getSmsGroupList.bind(this)}
        />

        <MessagePrivewDialog
          ref={this.messagePreviewDialogueRef}
          style={{ float: "right" }}
        />
        <div className="row">
          <div className="col">
            <div className="col md-12">
              <div className="card rounded-0">
                <div
                  className="row justify-content-between"
                  style={{ padding: "0.6em 1.2rem" }}
                >
                  <div className="d-flex col-12 col-lg-5 col-xl-5">
                    <div className="col-12 text-start totalResults">
                      <span>
                        Messages Scheduled: {this.state.scheduledCount}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7">
                    <div className="col-12 text-end">
                      <TextField
                        id="standard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.getScheduledSendList.bind(
                                  this,
                                  this.state.pageNo,
                                  this.state.pageSize
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  this.setState({ searchText: "" }, () => {
                                    this.getScheduledSendList(
                                      this.state.pageNo,
                                      this.state.pageSize
                                    );
                                  });
                                }}
                                disabled={!this.state.searchText}
                              >
                                <ClearIcon
                                  style={{
                                    opacity: this.state.searchText ? 1 : 0.4,
                                    fontSize: "1.25rem",
                                    color: "353538",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="table-responsive paginationTable">
                  <table className="table text-start table-hover">
                    <thead className="paginationTableThead">
                      <tr>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("hashColor")}>
                          {this.state.sortColumn === "hashColor" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("messageName")}
                        >
                          Message
                          {this.state.sortColumn === "messageName" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="col fw-bold cursor-pointer"
                          onClick={() => this.handleSort("messageType")}
                        >
                          Message Type
                          {this.state.sortColumn === "messageType" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="col fw-bold cursor-pointer"
                          onClick={() => this.handleSort("createdBy")}
                        >
                          Scheduled By
                          {this.state.sortColumn === "createdBy" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold cursor-pointer"
                          onClick={() => this.handleSort("scheduledDate")}
                        >
                          Scheduled Date/Time
                          {this.state.sortColumn === "scheduledDate" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}</th>
                        <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("contactCount")}>Contacts
                          {this.state.sortColumn === "contactCount" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th
                          className="cursor-pointer"
                          scope="col fw-bold"
                          onClick={() => this.handleSort("status")}
                        >
                          Status
                          {this.state.sortColumn === "status" &&
                            (this.state.sortDirection === "asc" ? (
                              <i
                                class="fa fa-long-arrow-up ps-1"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i class="fa-solid fa-arrow-down-long ps-1"></i>
                            ))}
                        </th>
                        <th className="col fw-bold">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.scheduledSendList?.map((rowData, index) => (
                        <tr
                          key={index}
                          // onClick={(e) => {
                          //   this.handleRowClick(e, rowData);
                          // }}
                          style={{
                            backgroundColor:
                              rowData.id === this.state.messageId
                                ? "#e6effc"
                                : "",
                          }}
                        >
                          <td
                            style={{ width: "40px" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <span
                              style={{
                                backgroundColor: rowData.hashColor,
                                width: 20,
                                height: 20,
                                borderRadius: 3,
                                display: "inline-block",
                                marginTop: "6px",
                                // border: "1px solid #ccc",
                              }}
                            />
                          </td>
                          <td
                            style={{ width: "240px" }}
                            onClick={(e) =>
                              this.handleAccountDropdownOpen(e, rowData)
                            }
                          >
                            <span
                              className="anchortag action-text"
                              style={
                                rowData.scheduledExpired
                                  ? { color: "#337ab7" }
                                  : { fontWeight: "bold" }
                              }
                            >
                              {rowData.messageName} &nbsp;
                              {rowData.isMms ? "(MMS)" : ""}
                            </span>
                          </td>
                          <td style={{ width: "160px" }}>
                            {rowData.messageType}
                          </td>
                          <td style={{ width: "200px" }}>
                            {rowData.createdBy}
                          </td>
                          {rowData.isMigrated && (
                            <td
                              className="action-button"
                              style={{ width: "250px" }}
                            >
                              <span
                                className="anchortag fw-bold"
                                onClick={(e) =>
                                  this.scheduledDilogBoxOpen(e, rowData)
                                }
                              >
                                Schedule now
                              </span>
                            </td>
                          )}
                          {rowData.isMigrationIssueResolved && (
                            <td
                              className="action-button"
                              style={{ width: "265px" }}
                            >
                              {this.state.getUpdatePermission ? (
                                <>
                                  {rowData.scheduledExpired ? (
                                    <>{rowData.scheduledDateTime}</>
                                  ) : (
                                    <span
                                      className="anchortag fw-bold"
                                      onClick={(e) =>
                                        this.editMessageDetails(e, rowData)
                                      }
                                    >
                                      {rowData.scheduledDateTime}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <span>{rowData.scheduledDateTime}</span>
                              )}
                            </td>
                          )}
                          <td
                            className="action-button"
                            style={{ width: "170px" }}
                          >
                            <span
                              className="anchortag"
                              style={
                                rowData.scheduledExpired
                                  ? { color: "#337ab7" }
                                  : { fontWeight: "bold" }
                              }
                              onClick={(e) =>
                                this.toRecipientsDetailList(e, rowData)
                              }
                            >
                              {`${rowData.contactCount} Numbers`}
                              &nbsp;
                              {rowData.status === "Scheduling" &&
                                <Tooltip title="Send in progress" classes={{ popper: "custom-tooltip" }}
                                  arrow >
                                  <svg width="10" height="30" viewBox="0 0 10 30">
                                    <rect x="2" y="20" width="6" height="8" rx="3" fill="#22c55e">
                                      <animate
                                        id="grow"
                                        attributeName="height"
                                        values="8;26;8"
                                        dur="1.2s"
                                        repeatCount="indefinite"
                                        calcMode="spline"
                                        keySplines="0.4 0 0.6 1;0.4 0 0.6 1"
                                      />
                                      <animate
                                        attributeName="y"
                                        values="20;2;20"
                                        dur="1.2s"
                                        repeatCount="indefinite"
                                        begin="grow.begin"
                                        calcMode="spline"
                                        keySplines="0.4 0 0.6 1;0.4 0 0.6 1"
                                      />
                                    </rect>
                                  </svg>
                                </Tooltip>
                              }
                            </span>
                          </td>
                          <td style={{ width: "160px" }}>
                            {rowData.status}
                          </td>
                          <td
                            className="action-button"
                            style={{ width: "160px" }}
                            key={rowData.id}
                          >
                            {this.showActionButton(rowData)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > 10 && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        Page {this.state.pageNo + 1} of {this.state.totalPages}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          pageNo={this.state.pageNo}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Menu
          anchorEl={this.state.anchorEl}
          id="dropdown-menu1"
          className="filterDropdownMenu"
          open={this.state.open}
          onClose={this.handleAccountDropdownClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 20,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        >
          <span className="closeIcon">
            <IconButton
              aria-label="close"
              onClick={this.handleAccountDropdownClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#000", fontWeight: "600" }} />
            </IconButton>
          </span>
          <div
            className="dropdown-item"
            style={{
              cursor: "pointer",
              width: "400px",
              height: "100%",
              fontSize: "14px",
            }}
          >
            <div className="p-4 pt-2 pb-2">
              <h5 className="fw-bold mb-2 ps-3">Message Preview</h5>
              <div className="col-md-12">
                <div className="chat-bubble">{this.state.messageContent}</div>
              </div>
            </div>
          </div>
        </Menu>
        <Dialog
          open={this.state.isScheduledOpen}
          onClose={this.scheduledDilogBoxClose.bind(this)}
          maxWidth="xl"
          className="scheduledNowDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Schedule now</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.scheduledDilogBoxClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent className="p-4">
            <div
              md={12}
              className="tableContact materialTable"
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
              }}
            >
              <div className="row">
                <ValidatorForm
                  className="text-start"
                  ref="form"
                  onSubmit={this.scheduleSendToBackend.bind(this)}
                >
                  <div className="row border-bottom border-2 p-3">
                    <div className="col-md-12">
                      <div className="row mb-3 d-flex">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-supplierType"
                          id="assetFormLabel"
                        >
                          Select Recipients
                        </label>
                        <div className="col-sm-4">
                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            autoComplete="off"
                            options={this.state.recipientTypeList}
                            value={this.state.recipientType}
                            ListboxProps={{
                              className: "custom-listbox",
                            }}
                            getOptionLabel={(option) => option?.description}
                            renderOption={(props, option) => (
                              <li {...props}>
                                {option?.description}
                                {option?.count !== 0 && (
                                  <span className="ms-2 fw-bold">
                                    {`(${option?.count})`}
                                  </span>
                                )}
                              </li>
                            )}
                            defaultValue={this.state.recipientType}
                            onChange={(event, value) => {
                              this.handleRecipientTypeChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                required
                                title=""
                                style={{ background: "#fff" }}
                              />
                            )}
                          />
                        </div>
                        {!this.state.sendToAllOptins && (
                          <p
                            className="col-sm-6 col-form-label fw-normal m-0 align-self-center"
                            htmlFor="basic-default-supplierType"
                            id="givbeeText"
                          >
                            Messages are sent to each selected recipient just
                            once.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      {!this.state.sendToAllOptins && (
                        <>
                          <div className="row mb-3 d-flex">
                            <div
                              className="col-md-12"
                            // style={{ borderRight: "3px solid #d9dee3" }}
                            >
                              <div className="row d-flex">
                                <label
                                  className="col-sm-2 col-form-label fw-bold"
                                  htmlFor="exampleFormControlTextarea1"
                                >
                                  Groups
                                </label>
                                <div className="col-md-10">
                                  <div className="row d-flex pt-1">
                                    {this.state.smsGroupList?.map(
                                      (item, index) =>
                                        item.count > 0 ? (
                                          <li
                                            className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                            style={{ width: "22em" }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={item.isactive}
                                              id={`checkbox-${item.id}`}
                                              onChange={(e) =>
                                                this.onGroupClicked(e, item.id)
                                              }
                                            />
                                            &nbsp;
                                            <span
                                              style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                document
                                                  .getElementById(
                                                    `checkbox-${item.id}`
                                                  )
                                                  .click()
                                              }
                                            >
                                              {item?.name}
                                            </span>
                                            <span
                                              className="ms-2"
                                              style={{
                                                cursor: "pointer",
                                                color: "#337AB7",
                                                fontWeight: "600",
                                              }}
                                            // onClick={this.toGroupDetails.bind(
                                            //   this,
                                            //   item
                                            // )}
                                            >
                                              {"(" + item.count + ")"}
                                            </span>
                                          </li>
                                        ) : (
                                          <li
                                            className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                            style={{
                                              width: "22em",
                                              color: "#cccccc",
                                            }}
                                          >
                                            <input
                                              disabled
                                              type="checkbox"
                                              checked={item.isactive}
                                            />
                                            &nbsp;
                                            <span
                                              style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              {item?.name}
                                            </span>
                                            <span
                                              className="ms-2"
                                              style={{
                                                color: "#cccccc",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {"(" + item.count + ")"}
                                            </span>
                                          </li>
                                        )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3 d-flex">
                            <div className="col-md-12">
                              <div className="row d-flex">
                                <label
                                  className="col-sm-2 col-form-label fw-bold pe-0"
                                  htmlFor="exampleFormControlTextarea1"
                                >
                                  Message Recipients
                                </label>
                                <div className="col-md-10">
                                  <div className="row d-flex pt-1">
                                    {this.state.smsActivityList.map(
                                      (item, index) =>
                                        item.activeContacts > 0 ? (
                                          <Tooltip
                                            arrow
                                            title={
                                              item.messageKeyword !== ""
                                                ? `Keyword: ${item.messageKeyword}`
                                                : ""
                                            }
                                            classes={{
                                              popper: "custom-tooltip",
                                            }}
                                          >
                                            <li
                                              className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                              style={{ width: "22em" }}
                                            >
                                              <input
                                                // className="checkbox"
                                                type="checkbox"
                                                checked={item.isactive}
                                                id={`checkbox-${item.id}`}
                                              // onChange={(e) =>
                                              //   this.onActivityClicked(
                                              //     e,
                                              //     item.id
                                              //   )
                                              // }
                                              />
                                              &nbsp;
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  document
                                                    .getElementById(
                                                      `checkbox-${item.id}`
                                                    )
                                                    .click()
                                                }
                                              >
                                                {`${item?.messageName} ${item?.messageKeyword !== ""
                                                  ? "(" +
                                                  item?.messageKeyword +
                                                  ")"
                                                  : ""
                                                  }`}
                                              </span>
                                              <span
                                                className="ms-2"
                                                style={{
                                                  cursor: "pointer",
                                                  color: "#337AB7",
                                                  fontWeight: "600",
                                                }}
                                                onClick={this.toActivityDetails.bind(
                                                  this,
                                                  item
                                                )}
                                              >
                                                {"(" +
                                                  item.activeContacts +
                                                  ")"}
                                              </span>
                                            </li>
                                          </Tooltip>
                                        ) : (
                                          <li
                                            className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                            style={{
                                              width: "22em",
                                              color: "#cccccc",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={item.isactive}
                                              disabled
                                            />
                                            &nbsp;
                                            <span
                                              style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              {`${item?.messageName} ${item?.messageKeyword !== ""
                                                ? "(" +
                                                item?.messageKeyword +
                                                ")"
                                                : ""
                                                }`}
                                            </span>
                                            <span
                                              className="ms-2"
                                              style={{
                                                color: "#cccccc",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {"(" + item.activeContacts + ")"}
                                            </span>
                                          </li>
                                        )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {this.state.lastActivity !== "None" && (
                        <div className="row">
                          <div className="col-md-2"></div>
                          <div className="col-md-9">
                            <li
                              className="list-group-item list-group-item-action border-0 prev d-flex"
                              style={{ color: "black", paddingLeft: "3px" }}
                            >
                              <input
                                type="checkbox"
                                checked={this.state.avoidRepeatSend}
                                onChange={(e) =>
                                  this.avoidRepeatSendMessages(e)
                                }
                              />
                              &nbsp;Do not send this message to the numbers it
                              was sent to before.
                            </li>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* <hr /> */}
                  <div className="row border-bottom border-2 p-3">
                    <div className="col-md-12">
                      <div className="row d-flex">
                        <div className="col-md-6">
                          <div className="row d-flex">
                            <div className="col-sm-4" id="assetFormLabel">
                              <label
                                className="col-sm-12 col-form-label fw-bold pt-0"
                                htmlFor="basic-default-supplierType"
                                id="assetFormLabel"
                              >
                                Send Options
                              </label>
                            </div>
                            <div className="col-sm-8 ps-0" id="assetFormLabel">
                              <>
                                <div
                                  className="row d-flex"
                                  style={{ marginTop: "28px" }}
                                >
                                  <div className="col-sm-12">
                                    <label
                                      className="MuiAutocomplete-label form-label fw-bold"
                                      htmlFor="multiStepsLastName"
                                    >
                                      Choose a Date/Time
                                    </label>
                                    <PtsDateTimePicker
                                      value={this.state.scheduledDateTime}
                                      onChange={this.handleScheduledDateTimeChange.bind(
                                        this
                                      )}
                                    />
                                    <span
                                      className="mt-2"
                                      style={{
                                        fontSize: "14.5px",
                                        color: "#000",
                                      }}
                                    >
                                      Time zone:
                                      <span
                                        className="ms-2"
                                        style={{
                                          cursor: "pointer",
                                          color: "#337AB7",
                                          fontWeight: "600",
                                          fontSize: "12px",
                                        }}
                                        onClick={this.navigateOrgTimeZone.bind(
                                          this
                                        )}
                                      >
                                        {`${this.orgTimeZone?.name} (${this.orgTimeZone?.abbreviation})`}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row ms-4 d-flex">
                            {this.state.scheduleErrorMessage && (
                              <>
                                <div
                                  className="col-sm-12 ps-1"
                                  id="assetFormLabel"
                                >
                                  <div class="form-check form-check-inline ps-0 d-flex">
                                    <input
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      type="checkbox"
                                      name="inlineCheckboxOptions"
                                      id="inlineCheckbox"
                                      checked={this.state.sendReminder}
                                      value={this.state.sendReminder}
                                      onChange={this.handleSendReminderChange.bind(
                                        this
                                      )}
                                    />
                                    <label
                                      class="form-check-label fw-bold ms-2"
                                      htmlFor="inlineRadio1"
                                    >
                                      Send me a reminder 24 hrs before the text
                                      is sent.
                                    </label>
                                  </div>
                                  {this.state.sendReminder && (
                                    <>
                                      <div className="row mt-1">
                                        <div className="col-sm-8">
                                          <label
                                            className="form-label"
                                            htmlFor="multiStepsLastName"
                                          >
                                            Mobile Phone
                                          </label>

                                          <span className="d-flex sendMsgPhoneInput">
                                            <PhoneInput
                                              country={this.defaultCountry?.code
                                                ?.toString()
                                                ?.toLowerCase()}
                                              onlyCountries={validCountryCodes}
                                              value={
                                                this.state.reminderCountryCode
                                              }
                                              onChange={(
                                                phone,
                                                country,
                                                e,
                                                formattedValue
                                              ) => {
                                                this.handleReminderCountryChange(
                                                  phone,
                                                  country,
                                                  e,
                                                  formattedValue
                                                );
                                              }}
                                              autoFormat
                                              countryCodeEditable={false}
                                              disableCountryGuess={false}
                                              enableSearch={true}
                                              alwaysDefaultMask={true}
                                            />
                                            <input
                                              // required
                                              type="text"
                                              autoComplete="off"
                                              name="multiStepsFirstName"
                                              className="form-control"
                                              style={{
                                                borderRadius: "0px 5px 5px 0px",
                                              }}
                                              value={
                                                this.state.reminderMobileNo
                                              }
                                              onChange={this.handleReminderMobileNoChange.bind(
                                                this
                                              )}
                                              validators={["required"]}
                                              errormessages={[
                                                "This field is required",
                                              ]}
                                            // onInvalid={(e) => {
                                            //   e.target.setCustomValidity(
                                            //     "Mobile number required"
                                            //   );
                                            // }}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                      <div className="row mt-1">
                                        <div className="col-sm-8">
                                          <label
                                            className="form-label"
                                            htmlFor="multiStepsLastName"
                                          >
                                            Email Address
                                          </label>
                                          <input
                                            type="email"
                                            autoComplete="off"
                                            id="multiStepsFirstName"
                                            name="multiStepsFirstName"
                                            className="form-control"
                                            value={this.state.reminderEmail}
                                            onChange={this.handleReminderEmailChange.bind(
                                              this
                                            )}
                                            validators={["required"]}
                                            errormessages={[
                                              "This field is required",
                                            ]}
                                          />
                                        </div>
                                      </div>
                                      {this.state.reminderErrorMessage ? (
                                        <lable
                                          className="danger mt-2"
                                          style={{
                                            color: "red",
                                          }}
                                        >
                                          Please enter either mobile phone or
                                          email address.
                                        </lable>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <hr /> */}
                  <div className="row pt-4 d-flex align-items-center justify-content-between">
                    <div className="col-sm-12 text-center">
                      <Button
                        className="me-4"
                        variant="contained"
                        type="submit"
                        style={{
                          padding: "2px 10px",
                          background: "#37517e",
                          color: "#fff",
                          fontSize: "14px",
                          fontWeight: "600",
                          width: "130px",
                          textTransform: "capitalize",
                        }}
                      >
                        Schedule Send
                      </Button>
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default withRouter(ScheduledSendList);
